import React, { Fragment } from 'react';
import { renderDisabledField } from '../../../helpers/formHelper';
import { isoCovertNumber, isoCovertString } from '../../../helpers/locationHelper';
import PassengerBar from './passengerbar';

const LeadPassenger = props => {

  const { leadPax: {first_name, family_name, email, iso_nationality, date_of_birth, telephone_country_code, telephone_number} } = props;
  const firstName = (first_name && first_name !== null) ? first_name : "";
  const lastName = (family_name && family_name !== null) ? family_name : "";
  const emailAddress = (email && email !== null) ? email : "";
  const nationality = (iso_nationality && iso_nationality !== null) ? isoCovertString(props.nationality, iso_nationality) : "";
  const dob = (date_of_birth && date_of_birth !== null) ? date_of_birth.split("-").reverse().join("/") : "";
  const contactNumber = (telephone_country_code && telephone_country_code !== null && telephone_number && telephone_number !== null) ? isoCovertNumber(props.nationality, telephone_country_code) + telephone_number : "";


  return (
    <Fragment>
      <PassengerBar title="Lead passenger" barClass="" status="Confirmed" icon="completed"/>
      <div className="confirm-modal-wrapper no-border-bottom leadpassenger">
        <div className="row">
            <div className="column small-12 medium-6 col-left-mod" style={{display:(firstName === "") ? "none" : "block"}}>
              { renderDisabledField('firstName', 'First Name', firstName) }
            </div>
            <div className="column small-12 medium-6 col-left-mod" style={{display:(lastName === "") ? "none" : "block"}}>
              { renderDisabledField('lastName', 'Last Name', lastName) }
            </div>

            <div className="column small-12 medium-6 col-left-mod" style={{display: (emailAddress === "") ? "none" : "block" }}>
              { renderDisabledField('email', 'E-mail address', emailAddress) }
            </div>
            <div className="column small-12 medium-6 col-left-mod" style={{display:(contactNumber === "") ? "none" : "block"}}>
              { renderDisabledField('contactNumber', 'Contact number', contactNumber) }
            </div>

            <div className="column small-12 medium-6 col-left-mod" style={{display:(nationality === "") ? "none" : "block"}}>
              { renderDisabledField('nationality', 'Nationality', nationality) }
            </div>
            <div className="column small-12 medium-6 col-left-mod" style={{display:(dob === "") ? "none" : "block"}}>
              { renderDisabledField('dob', 'Date of birth', dob) }
            </div>
        </div>
      </div>
    </Fragment>
  )
}

export default LeadPassenger;



// WEBPACK FOOTER //
// ./src/components/confirmation/components/leadpassenger.js